import Vue from 'vue';
import GeList from './ge-list';

Vue.component('ge-list', GeList);

export default GeList;



// WEBPACK FOOTER //
// ./scripts/ge-list/index.js